import {
  INVOICES,
  CUSTOMER,
  USERS,
  UPDATE_CUSTOMER,
  REACTIVATING,
  UPDATING_COUPON,
  UPDATING_BILLING,
  SUCCESS_SETTING
} from './BillingActions';

const INITIAL_STATE = {
  reactivating: false,
  updatingCoupon: false,
  updatingBilling: false,
  invoices: {},
  customer: {},
  users: [],
  settings: {}
};

const BillingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REACTIVATING:
      return {
        ...state,
        reactivating: true,
      };
    case UPDATING_COUPON: {
      return {
        ...state,
        updatingCoupon: action.value,
      };
    }
    case UPDATING_BILLING: {
      return {
        ...state,
        updatingBilling: action.value,
      };
    }
    case INVOICES:
      return {
        ...state,
        invoices: action.data,
      };
    case CUSTOMER:
      return {
        ...state,
        customer: action.data,
        updatingCoupon: false,
      };
    case USERS:
      return {
        ...state,
        users: action.data,
      };
    case UPDATE_CUSTOMER: {
      let customer = {
        ...state.customer,
        ...action.data,
      };
      return {
        ...state,
        reactivating: false,
        updatingBilling: false,
        customer,
      };
    }
    case SUCCESS_SETTING: {
      return { ...state, settings: action.settings };
    }
  }

  return state;
};

export default BillingReducer;
